import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { useSnackbar } from '../../context/SnackbarContext';
import { handleCompleteLogout } from '../../utils/authHelpers';

const LogoutButton: React.FC = () => {
  const { showSnackbar } = useSnackbar();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    if (isLoggingOut) return; // Prevent multiple clicks

    setIsLoggingOut(true);
    handleCompleteLogout().then(() => {
      showSnackbar('User logged out, redirecting to login page', 'success');
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
  };

  return (
    <Typography
      onClick={handleLogout}
      sx={{
        width: '100%',
        padding: 0,
        fontSize: '14px',
        fontWeight: 500,
        color: (theme) => theme.palette.error.main || '#d32f2f',
        opacity: isLoggingOut ? 0.6 : 1,
        cursor: isLoggingOut ? 'not-allowed' : 'pointer',
        pointerEvents: isLoggingOut ? 'none' : 'auto',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        letterSpacing: '-0.01em',
        '&:hover': {
          color: (theme) => theme.palette.error.main || '#d32f2f'
        }
      }}
    >
      {isLoggingOut ? 'Signing Out...' : 'Sign Out'}
    </Typography>
  );
};

export default LogoutButton;
